import * as Yup from 'yup';

const updateVarietyValidation = Yup.object().shape({
  rule: Yup.string().required(),
});

export default updateVarietyValidation;
